function getDocTitle(doc = {}) {
  return doc.name || doc.title || '';
}

export default getDocTitle;
